// extracted by mini-css-extract-plugin
export var dividerLine = "_5l-3";
export var itemImage = "_5l-9";
export var lightDivider = "_5l-4";
export var modalContent = "_5l-5";
export var modalContentCompact = "_5l-6";
export var productCard = "_5l-a";
export var productImage = "_5l-b";
export var productImageCompact = "_5l-7";
export var productImagePlaceholder = "_5l-c";
export var productImagePlaceholderCompact = "_5l-8";
export var progressBarBackground = "_5l-1";
export var progressBarContainer = "_5l-0";
export var progressBarFill = "_5l-2";